import { fetcher } from "@/shared/lib/fetcher.client";
import type { AppSettingsResponse } from "@/shared/types/appSettings.types";

export const appSettingsService = {
  async getAppSettings(): Promise<AppSettingsResponse> {
    const response = await fetcher<AppSettingsResponse>("/app-settings");
    return response.data;
  },
};
